import {
  Square,
  DoorOpen,
  DoorClosed,
  Droplets,
  Building2,
  Layers,
  Sun,
  Wrench,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES, waLink } from "@/lib/brand";

const ICONS = [Square, DoorOpen, DoorClosed, Droplets, Building2, Layers, Sun, Wrench];

export const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="relative py-24 lg:py-36 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-12 bg-[#facc15]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#facc15] font-bold">
                Nossos Serviços
              </span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white max-w-3xl">
              Soluções completas em
              <span className="italic text-[#facc15]"> alumínio</span> e vidro.
            </h2>
          </div>
          <a
            href={waLink("Olá! Quero falar sobre serviços de esquadrias.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="services-whatsapp-btn"
            className="inline-flex items-center gap-3 self-start lg:self-auto px-6 py-4 border border-white/20 text-white text-[11px] uppercase tracking-[0.28em] font-bold hover:bg-[#facc15] hover:text-black hover:border-[#facc15] transition-colors"
          >
            Falar no WhatsApp <ArrowUpRight size={16} strokeWidth={2} />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <article
                key={s.title}
                data-testid={`service-${i}`}
                className="group relative p-8 border-r border-b border-white/10 hover:bg-black transition-colors min-h-[280px] flex flex-col justify-between"
              >
                <Icon
                  size={36}
                  strokeWidth={1}
                  className="text-[#facc15] group-hover:scale-110 transition-transform duration-500"
                />
                <div>
                  <h3 className="font-display text-2xl text-white leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                    {s.desc}
                  </p>
                  <a
                    href={waLink(`Olá! Quero um orçamento para ${s.title}.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`service-${i}-whatsapp-btn`}
                    className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-bold text-[#facc15] hover:text-white transition-colors"
                  >
                    Orçar no WhatsApp
                    <ArrowUpRight size={14} strokeWidth={2} />
                  </a>
                </div>
                <ArrowUpRight
                  size={18}
                  strokeWidth={1.5}
                  className="absolute top-8 right-8 text-zinc-600 group-hover:text-[#facc15] group-hover:rotate-45 transition-all duration-500"
                />
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
